module.exports = __webpack_public_path__ + "static/img/12.b8d7a8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/12.png
// module id = f8vN
// module chunks = 0